'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.BrandfolderPrivacy = void 0;
(function(BrandfolderPrivacy) {
    BrandfolderPrivacy["Private"] = 'private';
    BrandfolderPrivacy["Public"] = 'public';
    BrandfolderPrivacy["Stealth"] = 'stealth';
})(exports.BrandfolderPrivacy || (exports.BrandfolderPrivacy = {}));
//# sourceMappingURL=brandfolder.js.map
